
























































import { TransformedInputField } from "@/components/form/InputFields";

import Vue from "vue";
import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required, urlValidator } from "@/shared/validationRules";
import {
  brandResource,
  produktResource,
  czcionkaResource,
  kolorResource,
  jednostkaSprzedazyResource,
  Wyrob,
  wyrobResource,
} from "@megarax/client/src/resources/plm";

const validationRules = {
  name: required,
  brand: required,
  nazwaHandlowa: required,
  jednostkaSprzedazy: required,
  opisTechniczny: [urlValidator],
};

export default createComponent({
  components: {
    TransformedInputField,
    DefaultRevisionForm,
  },
  props: {
    value: {
      type: Wyrob,
      required: true,
    },
  },
  setup(props, ctx) {
    function urlFormatter(input: string) {
      if (!input) return "";
      if (!input.startsWith("http")) return "http://" + input;
      if (input === "http://") return "";
      return input;
    }

    return {
      ...formValidator(),
      validationRules,
      urlFormatter,
      resource: wyrobResource,
      produktResource,
      brandResource,
      jednostkaSprzedazyResource,
      kolorResource,
      czcionkaResource,
    };
  },
});
